import React from "react";
import { Link } from "react-router-dom";
import { Typography } from "@mui/material";
import {
  TOP_64_MAX_POINTS_PER_PLAYER,
  TOP_64_PLAYER_COUNT,
  TOP_64_RULES_PATH,
  TOP_64_SCORING_TIERS,
} from "../../constants/top64Competition";

function CompetitionScoringGuide({ collapsible = false, open = true, onToggle }) {
  const maxScore = TOP_64_MAX_POINTS_PER_PLAYER * TOP_64_PLAYER_COUNT;

  return (
    <div className="create-ranking-scale-guide-inner create-ranking-competition-guide">
      <div className="create-ranking-scale-header">
        <Typography variant="subtitle2" component="h2" className="create-ranking-scale-title">
          Scoring
        </Typography>
        {collapsible && (
          <button
            type="button"
            className="create-ranking-scale-toggle"
            onClick={onToggle}
            aria-expanded={open}
          >
            {open ? "Hide" : "Show"}
          </button>
        )}
      </div>
      {(!collapsible || open) && (
        <>
          <Typography variant="caption" className="create-ranking-scale-subtitle">
            Points per drafted player. Max {maxScore.toLocaleString()} total.
          </Typography>
          <ol className="create-ranking-scale-list">
            {TOP_64_SCORING_TIERS.map((tier) => (
              <li key={tier.label} className="create-ranking-scale-item">
                <span className="create-ranking-scale-badge" aria-hidden>
                  {tier.points}
                </span>
                <div className="create-ranking-scale-copy">
                  <Typography
                    variant="body2"
                    component="span"
                    className="create-ranking-scale-label"
                  >
                    {tier.label}
                  </Typography>
                  <Typography variant="caption" component="p" className="create-ranking-scale-desc">
                    {tier.detail}
                  </Typography>
                </div>
              </li>
            ))}
            <li className="create-ranking-scale-item">
              <span className="create-ranking-scale-badge create-ranking-scale-badge--muted" aria-hidden>
                0
              </span>
              <div className="create-ranking-scale-copy">
                <Typography
                  variant="body2"
                  component="span"
                  className="create-ranking-scale-label"
                >
                  Not on your board
                </Typography>
                <Typography variant="caption" component="p" className="create-ranking-scale-desc">
                  Player drafted but missing from your ranking
                </Typography>
              </div>
            </li>
          </ol>
          <Link
            to={TOP_64_RULES_PATH}
            target="_blank"
            rel="noopener noreferrer"
            className="create-ranking-competition-rules-link"
          >
            View rules
          </Link>
        </>
      )}
    </div>
  );
}

export default CompetitionScoringGuide;
